import { effect, Injectable, signal } from '@angular/core';
import { IPurpleFitMenuItem } from './interfaces/IPurpleFitMenuItem';
import { Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitRegisterRequest, ApiPurpleFitUpdateUserInfoRequest, PRPVUserFull } from '../../core-modules/sdk';
import { environment } from '../../environments/default/environment';
import { PurpleTranslationService } from '@purple-lib/purple-translations-core';
import { PurpleSimpleNotificationService } from '@purple-lib/purple-ui-widgets';
import { PurpleUserService } from '@purple-lib/purple-users-core';
import { PurpleBreakpointsService, PurpleStorageService, PurpleStringExtensions } from '@purple-lib/purple-utilities';
import { PurpleFitCoreTranslations } from '../../core-modules/constants/purple-fit-core-translations';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  protected readonly T = PurpleFitCoreTranslations;

  constructor(private tsvc: PurpleTranslationService, private router: Router, private brakSvc: PurpleBreakpointsService,
    private psNotSvc: PurpleSimpleNotificationService, private location: Location, private storageSvc: PurpleStorageService, private userSvc: PurpleUserService<PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest>) {
    effect(() => {
      this.tsvc.currentLanguage();
      this.refreshMenuItems();
    });
  }
  currentActiveMenuitem: string | undefined;
  mobileTitle = signal<string | undefined>(undefined);

  headerIconFunction: (() => any) = async () => { await this.router.navigate([this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, 'home']) };
  showHeaderIcon: boolean = false;
  headerIconName: string | undefined;

  notLoggedMenu: IPurpleFitMenuItem[] = [];
  loggedMenu: IPurpleFitMenuItem[] = [];

  loggedTabMenu: IPurpleFitMenuItem[] = [];
  activeMenu: IPurpleFitMenuItem[] = this.notLoggedMenu;
  redirectUrl: string | undefined;
  footerButton = signal<{
    text: string,
    textKey: string,
    funct: () => any | Promise<any>,
    disabled: boolean
  } | undefined>(undefined);

  refreshMenuItems() {
    this.notLoggedMenu = [
      {
        id: "login",
        iconName: "login",
        name: this.tsvc.getTranslationValue(this.T.menu_public_login, []),
        relativeLink: [this.tsvc.currentLanguage(), "login"],
        queryParams: { redirectUrl: this.redirectUrl }
      },
      {
        id: "register",
        iconName: "form",
        name: this.tsvc.getTranslationValue(this.T.menu_public_register, []),
        relativeLink: [this.tsvc.currentLanguage(), "register"],
        queryParams: { redirectUrl: this.redirectUrl }
      },
      {
        id: "change-company",
        iconName: "icon-sync",
        name: this.tsvc.getTranslationValue(this.T.my_purple_fit_change_location, []),
        relativeLink: [this.tsvc.currentLanguage(), "change-company"],
        click: () => {
          this.changeCompany();

        }
        
      }
    ]

    this.loggedMenu = [
      {
        id: "home",
        iconName: "icon-home",
        name: this.tsvc.getTranslationValue(this.T.menu_private_home, []),
        relativeLink: [this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, "home"],
        queryParams: {},
        excludeRoles: ["teacher"]
      },
      {
        id: "home",
        iconName: "icon-home",
        name: this.tsvc.getTranslationValue(this.T.menu_private_home, []),
        relativeLink: [this.tsvc.currentLanguage(), `${environment.CLIENT_ROUTE}-trainer`, "home"],
        queryParams: {},
        exlusiveRoles: ["teacher"]
      },
      {
        id: "schedule",
        iconName: "icon-book",
        name: this.tsvc.getTranslationValue(this.T.menu_private_schedule, []),
        relativeLink: [this.tsvc.currentLanguage(), `${environment.CLIENT_ROUTE}-trainer`, "schedule"],
        queryParams: {},
        exlusiveRoles: ["teacher"]
      },

      {
        id: "class-calendar",
        iconName: "icon-book",
        name: this.tsvc.getTranslationValue(this.T.menu_private_class_calendar, []),
        relativeLink: [this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, "class-calendar"],
        queryParams: {},
        excludeRoles: ["teacher"]

      },
      {
        id: "products",
        iconName: "icon-credits",
        name: this.tsvc.getTranslationValue(this.T.menu_private_class_products, []),
        relativeLink: [this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, "products"],
        queryParams: {},
        excludeRoles: ["teacher"]

      }, {
        id: `my-${environment.CLIENT_ROUTE}`,
        iconName: "icon-user",
        name: this.tsvc.getTranslationValue(this.T.menu_private_my_purple_fit, []),
        relativeLink: [this.tsvc.currentLanguage(), `${environment.CLIENT_ROUTE}-trainer`, `my-${environment.CLIENT_ROUTE}`],
        queryParams: {},
        exlusiveRoles: ["teacher"]
      },
      {
        id: `my-${environment.CLIENT_ROUTE}`,
        iconName: "icon-user",
        name: this.tsvc.getTranslationValue(this.T.menu_private_class_my_purple_fit, []),
        relativeLink: [this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, `my-${environment.CLIENT_ROUTE}`],
        queryParams: {},
        excludeRoles: ["teacher"]
      },
    ]


    this.loggedTabMenu = [
      {
        id: "home",
        iconName: "icon-home",
        name: this.tsvc.getTranslationValue(this.T.menu_tab_private_home, []),
        relativeLink: [this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, "home"],
        queryParams: {},
        excludeRoles: ["teacher"]
      },
      {
        id: "class-calendar",
        iconName: "icon-calendar",
        name: this.tsvc.getTranslationValue(this.T.menu_tab_private_class_calendar, []),
        relativeLink: [this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, "class-calendar"],
        queryParams: {},
        excludeRoles: ["teacher"]

      },
      {
        id: `my-bookings`,
        iconName: "icon-book",
        name: this.tsvc.getTranslationValue(this.T.menu_tab_private_my_bookings, []),
        relativeLink: [this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, `my-${environment.CLIENT_ROUTE}`, "my-bookings"],
        queryParams: {},
        excludeRoles: ["teacher"]
      },
      {
        id: `my-packages`,
        iconName: "icon-wallet",
        name: this.tsvc.getTranslationValue(this.T.menu_tab_private_my_wallet, []),
        relativeLink: [this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, `my-${environment.CLIENT_ROUTE}`, "packages"],
        queryParams: {},
        excludeRoles: ["teacher"]
      },
      // {
      //   id: "products",
      //   iconName: "icon-credits",
      //   name: this.tsvc.getTranslationValue(this.T.menu_tab_private_class_products, []),
      //   relativeLink: [this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, "products"],
      //   queryParams: {},
      //   excludeRoles: ["teacher"]
      // },
      {
        id: `my-${environment.CLIENT_ROUTE}`,
        iconName: "icon-user",
        name: this.tsvc.getTranslationValue(this.T.menu_private_my_purple_fit, []),
        relativeLink: [this.tsvc.currentLanguage(), `${environment.CLIENT_ROUTE}`, `my-${environment.CLIENT_ROUTE}`, "home"],
        queryParams: {},
        excludeRoles: ["teacher"]
      },
      //TRAINER
      {
        id: "home",
        iconName: "icon-home",
        name: this.tsvc.getTranslationValue(this.T.menu_private_home, []),
        relativeLink: [this.tsvc.currentLanguage(), `${environment.CLIENT_ROUTE}-trainer`, "home"],
        queryParams: {},
        exlusiveRoles: ["teacher"]
      },
      {
        id: "schedule",
        iconName: "icon-book",
        name: this.tsvc.getTranslationValue(this.T.menu_private_schedule, []),
        relativeLink: [this.tsvc.currentLanguage(), `${environment.CLIENT_ROUTE}-trainer`, "schedule"],
        queryParams: {},
        exlusiveRoles: ["teacher"]
      },
      {
        id: `my-${environment.CLIENT_ROUTE}`,
        iconName: "icon-user",
        name: this.tsvc.getTranslationValue(this.T.menu_private_my_purple_fit, []),
        relativeLink: [this.tsvc.currentLanguage(), `${environment.CLIENT_ROUTE}-trainer`, `my-${environment.CLIENT_ROUTE}`],
        queryParams: {},
        exlusiveRoles: ["teacher"]
      },
    ]
  }

  setCurrentActiveMenuItem(menu?: string | undefined): void {
    this.currentActiveMenuitem = menu;
  }

  setCurrentActiveMenu(isLogged: boolean): void {
    if (!isLogged) {
      this.activeMenu = this.notLoggedMenu
    } else {
      this.activeMenu = this.brakSvc.breakPointDevice() == "desktop" || !environment.SHOW_TAB_MENU_MOBILE ?
        this.loggedMenu.filter(f => this.showMenu(f.maxLevel, f.minLevel, f.exlusiveRoles, f.excludeRoles)) :
        this.loggedTabMenu.filter(f => this.showMenu(f.maxLevel, f.minLevel, f.exlusiveRoles, f.excludeRoles));
    }
  }

  setFooterButton(req: { text: string, textKey: string, funct: () => any | Promise<any>, disabled: boolean } | undefined) {
    this.footerButton.set(req);
  }


  enableFooterButton(enabled: boolean) {
    if (this.footerButton()) {
      this.footerButton.set({
        ...this.footerButton()!,
        disabled: !enabled
      });
    }
  }

  showMenu(maxLevel: number | undefined, minLevel: number | undefined, exlusiveRoles: string[] | undefined, excludeRoles: string[] | undefined,) {
    const uRoleLevel = this.userSvc.currentUser?.roleLevel ?? 100;

    if (maxLevel != undefined && uRoleLevel > maxLevel) {
      return false;
    }

    if (minLevel != undefined && uRoleLevel < minLevel) {
      return false;
    }

    const uRoles = this.userSvc.currentUser?.roles ?? [];

    if (exlusiveRoles != undefined && !exlusiveRoles.some(element => uRoles.includes(element))) {
      return false;
    }

    if (excludeRoles != undefined && excludeRoles.some(element => uRoles.includes(element))) {
      return false;
    }

    return true;
  }

  checkIsCurrentMenu(menu: string): boolean {
    return PurpleStringExtensions.strEq(this.currentActiveMenuitem, menu) ?? false;
  }

  setPageHeader(title?: string | undefined, clickFunction?: (() => any) | undefined, showIcon?: boolean | undefined, iconName?: string | undefined): void {
    setTimeout(() => {
      this.mobileTitle.set(title);
      this.showHeaderIcon = showIcon ?? false;
      this.headerIconName = iconName;
      this.headerIconFunction = clickFunction ?? (async () => { await this.router.navigate([this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, 'home']) });
    }, 100);
  }

  logout() {
    this.psNotSvc.showPurpleSimpleNotification({
      title: this.tsvc.getTranslationValue(this.T.my_purple_fit_logout_title, []),
      message: this.tsvc.getTranslationValue(this.T.my_purple_fit_logout_message, [this.userSvc.currentUser?.user?.firstName!]),
      buttonText: this.tsvc.getTranslationValue(this.T.my_purple_fit_logout_ok_button),
      autoClose: true,
      buttonFunction: () => {
        var res = this.userSvc.logout();
        if (res) {
          this.router.navigate([this.tsvc.currentLanguage(), 'login'], {})
        } else {
          this.psNotSvc.showPurpleSimpleNotification({
            title: this.tsvc.getTranslationValue(this.T.my_purple_fit_logout_error_title, []),
            message: this.tsvc.getTranslationValue(this.T.my_purple_fit_logout_error_subtitle, []),
            buttonText: this.tsvc.getTranslationValue(this.T.my_purple_fit_logout_error_button, []),
            autoClose: false
          })
        }
      }
    }
    )
  }

  setRedirectUrl(params: Params, logged: boolean) {
    this.redirectUrl = params["redirectUrl"];
    this.refreshMenuItems();
    this.setCurrentActiveMenu(logged);
  }

  changeCompany() {
      this.psNotSvc.showPurpleSimpleNotification({
          title: this.tsvc.getTranslationValue(this.T.change_company_modal_title, []),
          message: this.tsvc.getTranslationValue(this.T.change_company_modal_message, []),
          buttonText: this.tsvc.getTranslationValue(this.T.change_company_modal_button, []),
          buttonFunction: () => {
            this.storageSvc.clear();
        this.location.historyGo(1);
        const url = `${this.tsvc.currentLanguage()}`;
        this.location.go(url);
        window.location.reload();
          },
          cancelBottonText: this.tsvc.getTranslationValue(this.T.change_company_modal_cancel_button, []),
          autoClose: true,
          cancelButtonFunction: () => {
            this.setCurrentActiveMenuItem("login")
          }
        });

  }
}

